import { useCallback } from 'react';
import useDisastersRepo from '../repository/disasterRepo';
import { useErisInformationStore } from '../store/ErisInformationStore';

function useDisasterService() {
  const { getLatestDisasterRequest, getPreviousDisasterRequest } = useDisastersRepo();
  const { setLatestDisasterUpdate, setPreviousDisasterUpdate } = useErisInformationStore();

  const getLatestDisaster = useCallback(async () => {
    const latestDisaster = await getLatestDisasterRequest();
    setLatestDisasterUpdate(latestDisaster);
  }, [getLatestDisasterRequest, setLatestDisasterUpdate]);

  const getPreviousDisaster = useCallback(async () => {
    const previousDisaster = await getPreviousDisasterRequest();
    setPreviousDisasterUpdate(previousDisaster);
  }, [getPreviousDisasterRequest, setPreviousDisasterUpdate]);

  return {
    getLatestDisaster,
    getPreviousDisaster,
  };
}

export default useDisasterService;
